'use client';

import { create } from 'zustand';

interface UseSearchPageStoreData {
  isLoading: boolean;
  setIsLoading(value: boolean): void;
  isMapOpen: boolean;
  toggleMap(open?: boolean): void;
  isMapExpanded: boolean;
  toggleMapExpansion(expanded?: boolean): void;
  isFiltersModalOpen: boolean;
  onOpenFiltersModal(): void;
  onCloseFiltersModal(): void;
  near: string;
  onNearChange(value: string): void;
  selectedCategories: string[];
  onSelectedCategoriesChange(value: string[]): void;
  includeNetworks: boolean;
  onIncludeNetworksChange(value: boolean): void;
}

export const useSearchPageStore = create<UseSearchPageStoreData>()(set => ({
  isLoading: false,
  setIsLoading(value) {
    set({ isLoading: value });
  },
  isMapOpen: true,
  toggleMap(open) {
    if (open !== undefined) {
      set({ isMapOpen: open });

      return;
    }

    set(state => ({ isMapOpen: !state.isMapOpen }));
  },
  isMapExpanded: false,
  toggleMapExpansion(expanded) {
    if (expanded !== undefined) {
      set({ isMapExpanded: expanded });

      return;
    }

    set(state => ({ isMapExpanded: !state.isMapExpanded }));
  },
  isFiltersModalOpen: false,
  onOpenFiltersModal() {
    set({ isFiltersModalOpen: true });
  },
  onCloseFiltersModal() {
    set({ isFiltersModalOpen: false });
  },
  near: '',
  onNearChange(value) {
    set({ near: value });
  },
  selectedCategories: [],
  onSelectedCategoriesChange(value) {
    set({ selectedCategories: value });
  },
  includeNetworks: true,
  onIncludeNetworksChange(value) {
    set({ includeNetworks: value });
  },
}));
